import React from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { COLORS } from "../../../assets/constants/styles";

export const Tab = ({ title, icon, name, isActive, setActiveTab, onClick }) => {
  let navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else if (name) {
      navigate(name);
      if (setActiveTab) setActiveTab();
    }
  };

  return (
    <TabContainer onClick={handleClick} $isActive={isActive}>
      <ContentContainer>
        <IconContainer>{icon}</IconContainer>
        <Caption>{title}</Caption>
      </ContentContainer>
    </TabContainer>
  );
};

const TabContainer = styled.div`
  background-color: ${(props) => (props.$isActive ? COLORS.violet : "white")};
  color: ${(props) => (props.$isActive ? "white" : COLORS.black)};
  cursor: pointer;
  transition: all 0.4s;
  border-radius: 0.75rem;
  height: 2rem;
  text-decoration: none;
`;

const IconContainer = styled.div`
  height: 20px;
  width: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-right: 4px;
`;

const Caption = styled.div`
  font-size: 0.75rem;
  font-weight: 700;
  line-height: 1.024rem;
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0.375rem 0.75rem;
`;
